import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HearAbout } from 'src/app/models/hear-about';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UtilityService } from 'src/app/services/utility.service';
@Injectable({
  providedIn: 'root',
})
export class HearAboutService {
  // Base url
  baseurl = environment.apiBase;
  constructor(private http: HttpClient, private utilityService: UtilityService) { }
  getAll() {
    return this.http.get<HearAbout[]>(this.baseurl + `/externals/GetHearAbouts/`)
      .pipe(map(userroleroles => {
        return userroleroles;
      }));
  }
}